import { Collapse, Empty, Flex, Tag } from 'antd';
import { FC } from 'react';

import { BaseQueryParams } from '@/common/interfaces';
import { getDateFactory } from '@/common/utils';

import { useSearchAndReplaceHistoryQuery } from '@/modules/Pages';

import { PagesSearchAndReplaceHistoryCountdown } from './PagesSearchAndReplaceHistoryCountdown';
import { PagesSearchAndReplaceHistoryInfo } from './PagesSearchAndReplaceHistoryInfo';

interface Props {
  history: BaseQueryParams<typeof useSearchAndReplaceHistoryQuery>['data'];
  loading: boolean;
  handleRollback: (version: string) => void;
}

export const PagesSearchAndReplaceHistoryModalView: FC<Props> = ({
  history,
  loading,
  handleRollback
}) => {
    if (!history.length) {
    return (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Історія пошуку та заміни порожня" />
    );
  }

  const items = history.map((historyItem) => ({
    key: historyItem.version,
    label: (
      <Flex style={{ width: '100%' }} align="center" justify="space-between" gap={8}>
        <span>{getDateFactory(new Date(historyItem.createdAt), 'August 16, 2018 08:02', true)}</span>
      </Flex>
    ),
    extra: (
      <Tag color="volcano" style={{ minWidth: '86px' }}>
        <PagesSearchAndReplaceHistoryCountdown expiresAt={historyItem.expiresAt} />
      </Tag>
    ),
    children: <PagesSearchAndReplaceHistoryInfo historyItem={historyItem} loading={loading} handleRollback={handleRollback} />,
  }));

  return (
    <Collapse
      defaultActiveKey={[history[0].version]}
      collapsible="header"
      items={items}
    />
  );
};
